import BlueButton from "../../../../common/BlueButton/BlueButton";
import PriceSelector from "../../../../common/PriceSelector";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const ImageSelectorFrame = ({
    setMetaData,
    setIsReporting,
    metaData,
    addTemplateToSelected,
    buttonIsHidden,
    statusMessage,
    selectedTemplates,
    removeSelectedTemplate,
    priceOptions,
}) => {
    const { t } = useTranslation("templatesPage");

    const getSelectedTemplateItem = (item) => {
        return selectedTemplates.length
            ? selectedTemplates.find(
                  (selected) => item.thumbnailUrl === selected.thumbnailUrl,
              )
            : false;
    };

    const defaultValueForPriceList =
        priceOptions && priceOptions.length > 1 ? "100" : "0";
    const templateIsSelected = getSelectedTemplateItem(metaData);

    useEffect(() => {
        metaData.newPrice = defaultValueForPriceList;
    }, [defaultValueForPriceList, metaData]);

    //render button or message
    let buttonState;

    if (!templateIsSelected) {
        buttonState = (
            <BlueButton
                text={t("selectButton")}
                onClick={addTemplateToSelected}
                isCenter={true}
            />
        );
    } else {
        buttonState = (
            <BlueButton
                text={t("unselectButton")}
                onClick={removeSelectedTemplate}
                isCenter={true}
                isDark={true}
            />
        );
    }

    if (buttonIsHidden)
        buttonState = (
            <p className="ImageSelectorStatusMessage">{statusMessage}</p>
        );

    const buttonXClick = () => {
        const animationduration = 100;
        const notifcationContainerAnimation = document.getElementById(
            "ImageSelectorAnimationContainer",
        );
        if (notifcationContainerAnimation)
            notifcationContainerAnimation.animate(
                [{ transform: "scale(1)" }, { transform: "scale(0,1)" }],
                {
                    duration: animationduration,
                    once: true,
                },
            );

        setTimeout(() => setMetaData(null), animationduration);
    };

    const priceSelectorContent = templateIsSelected ? (
        <></>
    ) : (
        <PriceSelector
            defaultValue={defaultValueForPriceList}
            onChange={(e) => (metaData.newPrice = e.target.value)}
            priceList={priceOptions}
            isValid={true}
        />
    );

    let content = (
        <div className="imageSelectorBackButtonContainerWrapper">
            <div className="ImageSelectorBackButtonContainer">
                <button
                    className="ImageSelectorBackButton"
                    onClick={buttonXClick}
                >
                    X
                </button>
            </div>
            <div className="reportFlagContainer">
                <p className="reportFlag" onClick={() => setIsReporting(true)}>
                    {t("browesPageReportImageButton")}
                </p>
            </div>
            <h3 className="ImageSelectorTitle">
                {metaData.name ? metaData.name : metaData.title}
            </h3>
            <hr className="ImageSelectorLineBreak" />
            <br />
            <img
                className="imageGridDisplay"
                src={metaData.thumbnailUrl}
                alt={metaData.title}
                onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/imageNotFound.jpg";
                }}
            />
            <br />
            <div className="ImageSelectorMetaDataContent">
                <p>{t("browesPageCreatorName", { name: metaData.uploader })}</p>
                {priceSelectorContent}
            </div>
            <br />
            <br />
            {buttonState}
        </div>
    );

    return content;
};

export default ImageSelectorFrame;
